import Vue from 'vue';
import VueRouter from 'vue-router';
// views to route to
import Gallery from '@/views/Gallery';
import LogSearch from "@/views/LogSearch";
import Watchlists from "@/views/Watchlists";
import Watchlist from "@/components/watchlist/Watchlist";
import Detail from "@/views/Detail";

Vue.use(VueRouter);

export default new VueRouter({
	//mode: 'history',
	routes: [
		{path: "/", component: Gallery},
		{path: "/products", name: "products", component: Gallery},
		{path: "/search", name: "search", component: LogSearch},
		{path: "/detail/:identifier", name: "detail", component: Detail, props: true, meta: {requiresAuth: false}},
		{path: "/detail/w/:identifier", name: "watchlistItemDetail", component: Detail, props: true, meta: {isWatchlistItem: true}},
		{path: "/detail/s/:hash/:identifier", name: "watchlistItemSharedDetail", component: Detail, props: true, meta: {requiresAuth: false, isWatchlistItem: true, isPublic: true}},
		{path: "/detail/ds/:hash/:identifier", name: "dynamicWatchlistItemDetail", component: Detail, props: true, meta: {requiresAuth: false, isWatchlistItem: true, isDynamicWatchlistItem: true, isPublic: true}},
		{path: "/watchlists", name: "watchlists", component: Watchlists},
		{path: "/watchlists/:id", name: "watchlistDetail", component: Watchlist, props: true},
		{path: "/zohowatchlist/:entityId", name: "zohoWatchlist", component: Watchlist, props: true},
		{path: "/watchlist/:hash", name: "sharedWatchlist", component: Watchlist, props: true, meta: {requiresAuth: false, isPublic: true}}
	]
});